<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="app" style="background-color: #e8ebed">
    <!-- 医院标题 -->
    <section class="thick" style="margin-bottom: 0px">
      <div class="hospital-logo-line">
        <span class="logo-img"></span>
        <span class="logo-title" id="register-hospital-title">{{ hospitalName }}</span>
      </div>
    </section>
    <div class="hos-info-name"></div>
    <div class="hospital-content">
      <div v-html="hospitalContent"></div>
<!--        <div style="color:#4C4C4C ;font-weight: bold;text-indent: 30px">感谢您选择彭州市妇幼保健院就诊！我院提供网上预约、电话预约、现场预约、微信预约、自助机预约等多种预约服务</div>
        <div style="color: red ;margin-top: 5px;" ><span style="color: #1d1d26;font-weight: bold"><b>1、微信预约：可预约未来7天的号源（每天23:00-次日01:00为系统维护时间，暂停预约）。</b></span>首次预约请关注我院公众微信号&#45;&#45;选择“就诊服务”&#45;&#45;选择“电子健康卡”&#45;&#45;上传身份证照片或实名填写就诊者信息，一个手机号可绑定四张卡，同一人不能同时注册多个手机。<span style="color: #1d1d26;font-weight: bold"><b>不同的专科需分别挂号。</b></span></div>
        <div style="margin-top: 5px;color: #ff0000 ">2、就诊流程：①请早于预约时间前30分钟到院签到，按就诊科室签到规则就诊，过号或复诊需再次签到。②迟于预约时间签到有迟到惩罚，全年迟到≥3次取消3个月预约挂号的资格。</div>
        <div style="margin-top: 5px;color:#4C4C4C"><span style="color: #1d1d26;font-weight: bold">3、电话预约：</span>可拨打86239677预约挂号，时间08:00-17:00，就诊当日凭就诊者有效身份证件，如：身份证、户口簿、社会保障卡、护照、军官证或电子健康卡二维码到门诊大厅（1—5号窗口）处缴费取号，时间为每天08:00-16:00，信息错误医院不发放预约号源。</div>
        <div style="margin-top: 5px;color:#4C4C4C"><span style="color: #1d1d26;font-weight: bold">4、医生停诊：</span>当医生临时停诊，我院将通过微信、网络公布停诊信息，同时电话告知已预约的用户。</div>
        <div style="color: red ;margin-top: 5px;" ><span style="color: #1d1d26;font-weight: bold"><b>5、取消预约：</b></span>如您无法按时就诊，请于就诊前2小时内退号。<span style="color: #1d1d26;font-weight: bold"><b>电话预约可拨打电话86239677取消，微信预约可自助取消，自助机预约需到现场取消。</b></span></div>
        <div style="margin-top: 5px;color:#4C4C4C"><span style="color: #1d1d26;font-weight: bold">6、咨询电话：</span>86239677（时间：08：00—17：00）</div>-->
    </div>
    <footer>
      <div v-show="divShow" style="margin-left:10px">
        <input id="color-input-red" class="chat-button-location-radio-input" type="checkbox" name="color-input-red"
               value="#f0544d" @click="theSelected"/>
        <label for="color-input-red"></label>
        <div class="hos-hint">阅读并同意《预约须知》</div>
      </div>
      <div style="height:5px"></div>
      <div>
        <button id="btn-submit" class="btn-ok" style="width: 96%;margin-left: 2%" type="button" @click="confirmRegister" :disabled='disabled'>
          {{ content }}
        </button>
      </div>
      <div style="height:1px"></div>
    </footer>
  </div>
</template>
<script>
import utils from 'utils'

export default {
  data() {
    return {
      totalTime: 5,
      content: "5S",
      divShow: false,
      checkbox: false,
      disabled: true,
      backgroundColor: "#AAAAAA",
      hospitalName: "",
      hospitalContent: ""
    }
  },
  mounted() {
    this.refresh();
    this.getCountdown();
  },
  methods: {
    theSelected() {
      this.checkbox = event.target.checked
    },
    confirmRegister() {
      if (!this.checkbox) {
        utils.alert('请先勾选《预约须知》！')
        return
      }
      this.$router.push(this.$store.state.paramModule.param.menu.url);
    },
    getCountdown() {
      document.getElementById("btn-submit").style.background = this.backgroundColor;
      let clock = window.setInterval(() => {
        this.content = this.totalTime + 'S';
        this.totalTime--;
        if (this.totalTime < 0) {
          this.totalTime = 5;
          this.content = "确认";
          this.divShow = true;
          this.disabled = false;
          this.backgroundColor = "#39c451";
          document.getElementById("btn-submit").style.background = this.backgroundColor;
          window.clearInterval(clock);
        }
      }, 1000);
    },
    refresh() {
      this.hospitalName = this.$store.state.paramModule.param.registeredPrompt.hospitalName;
      this.hospitalContent = this.$store.state.paramModule.param.registeredPrompt.hintContent;
    }
  }
}
</script>
<style lang="scss">
@import '../../../static/sass/_variable.scss';

.hos-info-name {
  border-bottom: 1px solid #d7d7d7;
  margin: 1rem
}

.hospital-content {
  margin-left: 4%;
  position: relative;
  width: 92%;
  overflow-y: auto;
  height: 70%;
  text-align: left;
}

.hos-hint {
  color: #AAAAAA;
  margin-top: -20px;
  margin-left: 22px;
}

#color-input-red + label {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  top: 2px;
  left: 15px;
  background: #AAAAAA;
}

#color-input-red:checked + label::before {
  display: block;
  content: "\2714";
  text-align: center;
  font-size: 16px;
  color: white;
}
</style>


// WEBPACK FOOTER //
// registeredPrompt.vue?24fd6ad8